import { useEffect, useRef } from 'react'

/** Custom hook that allows you to react to a specific `CustomEvent`. */
export function useCustomEventListener<E extends unknown>(
  /** The name of the custom event to react to */
  eventName: string,
  /** The handler method that is executed when the custom event is emitted. */
  eventHandler: (event: CustomEvent<E>) => void
) {
  const eventHandlerRef = useRef(eventHandler)
  eventHandlerRef.current = eventHandler

  useEffect(() => {
    const handler = (event: Event) => {
      const customEvent = event as CustomEvent<E>
      eventHandlerRef.current(customEvent)
    }
    window.addEventListener(eventName, handler)
    return () => window.removeEventListener(eventName, handler)
  }, [eventName])
}
